import {FeatureGroup} from "../model/feature-group.model";

export class CreateFeatureGroupDto extends FeatureGroup{

  constructor() {
    super();
  }

}
